import { render, staticRenderFns } from "./PatientWeightInput.vue?vue&type=template&id=58640b8c&scoped=true&"
import script from "./PatientWeightInput.vue?vue&type=script&lang=js&"
export * from "./PatientWeightInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientWeightInput.vue?vue&type=style&index=0&id=58640b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58640b8c",
  null
  
)

export default component.exports